import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4266520a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "header_title time" };
const _hoisted_3 = { class: "title_label" };
const _hoisted_4 = { class: "header_title side" };
const _hoisted_5 = { class: "title_label" };
const _hoisted_6 = { class: "header_title other" };
const _hoisted_7 = { class: "title_label" };
const _hoisted_8 = { class: "header_title other" };
const _hoisted_9 = { class: "title_label" };
const _hoisted_10 = { class: "header_title amount" };
const _hoisted_11 = { class: "title_label" };
const _hoisted_12 = { class: "header_title action" };
const _hoisted_13 = { class: "title_label" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header_title cancel" }, null, -1));
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, OPEN_ORDERS_HEADERS } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).TIME)), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).SIDE)), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).PAIR)), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).PRICE)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).EXCUTED_AND_AMOUNT)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(format)(_unref(OPEN_ORDERS_HEADERS).ACTION)), 1)
                ]),
                _hoisted_14
            ]));
        };
    }
});
